import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export type InfoPageTemplate =
  | 'imprint'
  | 'terms-of-service'
  | 'privacy-terms'
  | 'system-requirements'
  | 'contact-sdv'
  | 'consent-proctoring-sdv';

@Component({
  selector: 'app-info-page-dialog',
  templateUrl: './info-page-dialog.component.html',
})
export class InfoPageDialogComponent {
  @Input() template!: InfoPageTemplate;

  constructor(protected bsModalRef: BsModalRef) {}
}
